<template lang="html">
  <div :class="theClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      default: null,
    },
  },
  computed: {
    theClass() {
      let c = 'row';
      if (this.size) {
        c += ' size-' + this.size;
      }
      return c;
    },
  },
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/parts/layout/row.vue